// ─────────────────────────────────────────────────────────────────────────────
// KnowledgeBase Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the Knowledge Base document store slice.
// Covers: CRUD, filter/search, download, and UI state.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { IKbDocument, IKbUpdateRequest, IKbUploadRequest, KbDocumentType } from '../models/knowledge-base.models';

// ─── Load documents ──────────────────────────────────────────────────────────

export const LoadDocuments = createAction('[KnowledgeBase] Load Documents');
export const LoadDocumentsSuccess = createAction('[KnowledgeBase] Load Documents Success', props<{ documents: IKbDocument[] }>());
export const LoadDocumentsError = createAction('[KnowledgeBase] Load Documents Error', props<{ error: string }>());

// ─── Filter & search ─────────────────────────────────────────────────────────

export const SetTypeFilter = createAction('[KnowledgeBase] Set Type Filter', props<{ filterType: KbDocumentType | 'all' }>());
export const SetSearchQuery = createAction('[KnowledgeBase] Set Search Query', props<{ query: string }>());
export const SetSort = createAction('[KnowledgeBase] Set Sort', props<{ sortKey: string; sortMode: 'asc' | 'desc' }>());

// ─── Upload document ─────────────────────────────────────────────────────────

export const UploadDocument = createAction('[KnowledgeBase] Upload Document', props<{ request: IKbUploadRequest }>());
export const UploadDocumentSuccess = createAction('[KnowledgeBase] Upload Document Success', props<{ document: IKbDocument }>());
export const UploadDocumentError = createAction('[KnowledgeBase] Upload Document Error', props<{ error: string }>());

// ─── Delete document ─────────────────────────────────────────────────────────

export const DeleteDocuments = createAction('[KnowledgeBase] Delete Documents', props<{ documentIds: string[] }>());
export const DeleteDocumentsSuccess = createAction('[KnowledgeBase] Delete Documents Success', props<{ documentIds: string[] }>());
export const DeleteDocumentsError = createAction('[KnowledgeBase] Delete Documents Error', props<{ error: string }>());

// ─── Update document (file + metadata via dialog) ────────────────────────────

export const UpdateDocument = createAction('[KnowledgeBase] Update Document', props<{ request: IKbUpdateRequest }>());
export const UpdateDocumentSuccess = createAction('[KnowledgeBase] Update Document Success', props<{ document: IKbDocument }>());
export const UpdateDocumentError = createAction('[KnowledgeBase] Update Document Error', props<{ error: string }>());

// ─── Download documents ──────────────────────────────────────────────────────

export const DownloadDocuments = createAction('[KnowledgeBase] Download Documents', props<{ documentIds: string[] }>());

export const DownloadDocumentsSuccess = createAction('[KnowledgeBase] Download Documents Success', props<{ documentIds: string[] }>());

export const DownloadDocumentsError = createAction('[KnowledgeBase] Download Documents Error', props<{ error: string }>());

// ─── Toggle expanded row ─────────────────────────────────────────────────────

export const ToggleDocumentExpanded = createAction('[KnowledgeBase] Toggle Document Expanded', props<{ documentId: string }>());
